import { Base } from './_base.model';

export class UploadForm extends Base {
  id: number;
  name: string;
  event_card_category_id: string;
  client_receipt: boolean;
  client_signin: boolean;
  speaker_receipt: boolean;
  speaker_travel: boolean;
  speaker_payment: boolean;
}